import React, { useEffect, useState } from "react";
import { useInternalNotesCampaignMutation } from "../../../Services/campign/CampaignDetail";
import { useParams } from "react-router-dom";
import { Loader } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";
import "../../ticket/ticketListInfo/Messages.scss";
interface IPROPS {
  internalNotes: any;
  fetchingNotes: any;
  notesData: any;
  refetchLeadTrail: any;
  showCompose: boolean;
  setShowCompose: (show: boolean) => void;
}

const InternalMessageCamapign: React.FC<IPROPS> = ({
  internalNotes,
  fetchingNotes,
  notesData,
  refetchLeadTrail,
  showCompose,
  setShowCompose,
}) => {
  const [content, setContent] = useState("");
  const [initials, setInitials] = useState<string>("");
  const [username, setUsername] = useState<string>("");
  const [files, setFiles] = useState([]);

  const { uuid } = useParams();

  const [trigger, { data: internoteData, isLoading, isError }] =
    useInternalNotesCampaignMutation();

  function formatDate(dateString: string) {
    const date = new Date(dateString);

    // Extract components
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Format the date and time
    const formattedDate = `${day}/${month}/${year}`;
    const formattedTime = `${hours}:${minutes}`;

    return `${formattedDate} ${formattedTime}`;
  }

  const internalNoteSubmitHandler = async () => {
    setShowCompose(false);

    const internalNoteObj = {
      attachments: files,
      content: content,
      lead: uuid,
      assigned_by: localStorage.getItem("circleone-username"),
      assignee: localStorage.getItem("User_Id"),
      status_type: notesData?.status_type,
    };
    try {
      const result = await trigger(internalNoteObj).unwrap();
      toast.success("Note saved successfully");
      setContent(""); // clear content
      setFiles([]); //clear attchment
      fetchingNotes();
      refetchLeadTrail();
    } catch (error) {}
  };

  useEffect(() => {
    const storedUsername = localStorage.getItem("circleone-username") || "";
    const nameParts = storedUsername.split(" ");
    const generatedInitials = nameParts
      .map((part) => part.charAt(0))
      .join("")
      .toUpperCase();

    setInitials(generatedInitials);
    setUsername(storedUsername);
  }, []);

  const handleDeleteFile = (fileToDelete) => () => {
    setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToDelete));
  };

  const handleFileChange = async (event) => {
    const newFiles = Array.from(event.target.files);
    const filePromises = newFiles.map((file: any) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const fileData = {
            file_name: file.name,
            file: e.target.result.split(",")[1],
          };
          resolve(fileData);
        };
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    });

    try {
      const fileDataArray = await Promise.all(filePromises);
      setFiles((prevFiles) => [...prevFiles, ...fileDataArray]);
    } catch (error) {
      toast.error("An error occurred while uploading files. Please try again.");
    }
  };

  const getAvatarColor = (index: number) => {
    const colors = ["avatar-blue", "avatar-green", "avatar-purple"];
    return colors[index % colors.length];
  };

  return (
    <div>
      {showCompose && (
        <div className="compose-note">
          <textarea
            className="compose-textarea"
            placeholder="Write a note..."
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows={3}
          />

          {files.length > 0 && (
            <div className="compose-attachments">
              {files.map((file, index) => (
                <div key={index} className="custom-chip">
                  <i className="bi bi-paperclip attachment-icon"></i>
                  <span>{file.file_name}</span>
                  <i
                    className="bi bi-x chip-delete-icon"
                    onClick={handleDeleteFile(file)}
                  ></i>
                </div>
              ))}
            </div>
          )}

          <div className="compose-footer">
            <div className="compose-actions">
              <label
                htmlFor="attachFileInputInternal"
                className={`action-btn ${!content ? "disabled" : ""}`}
                title="You can add attachments for the following 
           file types: xls,pdf,csv,doc,jpg,png up to a maximum size of 15MB"
              >
                <i className="bi bi-paperclip"></i>
                <input
                  type="file"
                  id="attachFileInputInternal"
                  multiple
                  onChange={handleFileChange}
                  disabled={!content}
                />
              </label>
            </div>

            <div className="compose-submit">
              <button className="btn-send" onClick={internalNoteSubmitHandler}>
                {isLoading ? (
                  <>
                    Saving.. <Loader />
                  </>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="notes-list">
        {internalNotes && internalNotes.length > 0 ? (
          internalNotes.map((el: any, index: number) => (
            <div className="note-item" key={el.id}>
              <div className="note-avatar">
                <div className={`avatar-circle ${getAvatarColor(index)}`}>
                  {initials}
                </div>
              </div>

              <div className="note-content">
                <div className="note-header">
                  <div className="note-author">
                    <span className="author-name">
                      {username.split("@")[0]}
                    </span>
                    <span className="note-dot"></span>
                    <span className="note-timestamp">
                      {el?.created ? formatDate(el.created) : "Just now"}
                    </span>
                  </div>
                  <div className="note-actions">
                    <button title="More actions">
                      <i className="bi bi-three-dots"></i>
                    </button>
                  </div>
                </div>

                <p className="note-text">{el?.content}</p>

                {el.attachments?.length > 0 && (
                  <div className="note-attachments">
                    {el.attachments.map((attachment, idx) => (
                      <div
                        key={attachment.id}
                        className="attachment-chip"
                        onClick={() => {
                          const newWindow = window.open(
                            attachment.file,
                            "_blank",
                          );
                          if (
                            !newWindow ||
                            newWindow.closed ||
                            typeof newWindow.closed === "undefined"
                          ) {
                            alert(
                              "Popup blocked! Please allow popups for this site.",
                            );
                          }
                        }}
                      >
                        <i className="bi bi-paperclip attachment-icon"></i>
                        <span>
                          {attachment.file_name || `Attachment ${idx + 1}`}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <p>No internal notes yet. Click "Add Note" to create one.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default InternalMessageCamapign;
